import React from 'react';
import ThinkingDarkSvg from '../../../assets/img/thinkingDark.svg';
import ThinkingLightvg from '../../../assets/img/thinkingLight.svg';

interface ThinkingLoaderProps {
    size?: number;
}

export const ThinkingLoader = ({ size = 32 }: ThinkingLoaderProps) => {
    return (
        <div className="relative flex items-center justify-center">
            <img className="dark:hidden" src={ThinkingLightvg} alt="Thinking..." width={size} height={size} />
            <img className="hidden dark:block" src={ThinkingDarkSvg} alt="Thinking..." width={size} height={size} />
        </div>
    );
};
